import { z } from 'zod';

import { Aggregated_Audience_Operator } from '@occc/graphql';
import { IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';

const audiencesError = 'At least two audiences are required';

const audiencesSchema = z
  .union([
    z
      .array(z.object({ uuid: z.string(), name: z.string() }).passthrough())
      .length(0, { message: audiencesError }),
    z.array(z.object({ uuid: z.string() }).passthrough()).min(2),
  ])
  .optional();

export const combinedAudiencesSchema = z
  .object({
    audiences: audiencesSchema,
    operator: z.nativeEnum(Aggregated_Audience_Operator, {
      required_error: IS_REQUIRED,
    }),
  })
  .optional();
